import React from 'react';

function BackButtonModal({ onConfirm, onCancel }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 p-4 animate-fade-in">
      <div className="w-full max-w-sm rounded-lg bg-white p-6 shadow-2xl animate-float-in dark:bg-slate-900">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-950/40">
            <svg className="h-7 w-7 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
          <h2 className="text-lg font-black text-slate-900 dark:text-slate-50">Leave this page?</h2>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">You pressed the back button. Confirming will logout your current session.</p>
        </div>
        <div className="flex gap-3">
          <button onClick={onCancel} className="min-h-11 flex-1 rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-black text-slate-600 transition-all duration-150 hover:bg-slate-50 active:scale-[0.97] dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800">Stay here</button>
          <button onClick={onConfirm} className="min-h-11 flex-1 rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-black text-white transition-all duration-150 hover:bg-amber-600 active:scale-[0.97]">Yes, logout</button>
        </div>
      </div>
    </div>
  );
}

export default BackButtonModal;
